<style scoped>
    .title{color: #464c5b;font-size: 14px;border-bottom: 1px solid #d7dde4;border-top: 1px solid #d7dde4;line-height: 62px;text-align: center;}
</style>
<template>
  <div>
    <div>
      <p style="font-size: 14px;color: #464c5b;margin-bottom: 40px;"><span style="font-weight: bold;">客户冲突项</span> <span style="color: #657180;">| 共{{peopleConflict.length}}项目</span></p>
      <Row class="title" style="font-weight: bold;">
        <Col span="5">委托人</Col>
        <Col span="5">诉讼地位</Col>
        <Col span="5">联系人</Col>
        <Col span="5">录入时间</Col>
        <Col span="4">关联项目</Col>
      </Row>
      <Row class="title" style="border-top: 0" v-for="(item,index) in peopleConflict">
        <Col span="5">{{item.name||'未知'}}</Col>
        <Col span="5">{{item.litigation||'未知'}}</Col>
        <Col span="5">{{item.contactName||'未知'}}</Col>
        <Col span="5">{{item.createDate||'未知'}}</Col>
        <Col span="4">{{item.caseNum||'未知'}}</Col>
      </Row>
    </div>
    <div style="margin-bottom: 40px;">
      <p style="font-size: 14px;color: #464c5b;margin-bottom: 40px;margin-top: 40px"><span style="font-weight: bold;">项目冲突项 </span> <span style="color: #657180;">| 共{{projectConflict.length}}项目</span></p>
      <Row class="title" style="font-weight: bold;">
        <Col span="5">案号</Col>
        <Col span="5">代理何方</Col>
        <Col span="5">联系人</Col>
        <Col span="5">立项时间</Col>
        <Col span="4">案件类型</Col>
      </Row>
      <Row class="title" style="border-top: 0" v-for="(item,index) in projectConflict">
        <Col span="5">{{item.caseNum||'未知'}}</Col>
        <Col span="5">{{item.delegableRole||'未知'}}</Col>
        <Col span="5">{{item.contactName||'未知'}}</Col>
        <Col span="5">{{item.createDate||'未知'}}</Col>
        <Col span="4">{{item.caseType||'未知'}}</Col>
      </Row>
    </div>
    <div style="padding:10px"></div>
    <Row :gutter="20" type="flex" justify="center">
      <Col span="4">
        <router-link :to="{name:lastRoute,query:{id:$route.query.id}}"><Button type="primary" style="width:100%">上一步</Button></router-link>
      </Col>
      <Col span="4" v-if="projectConflict.length<1&&peopleConflict.length<1||lastRoute.length<1">
        <router-link :to="{name:nextRoute,query:{id:$route.query.id}}"><Button type="primary" style="width:100%;">下一步</Button></router-link>
        <!--<router-link :to="{name:nextRoute,params:{personal:personal,company:company}}"></router-link>-->
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: "step2",//利冲报告
    props:{
      nextRoute:String,
      lastRoute:String,
    },
    data:function () {
      return{
        projectConflict:[],
        peopleConflict:[],
      }
    },
    mounted:function(){
      this.checkConflict()
      this.getLitigationStatus()
    },
    methods:{
      getLitigationStatus:function () {
        var _this = this
        _this.send({
          headers:'C/ShowIdentity',
          success:function (res) {
            _this.identity = []
            for(var index in res.LitigantTypeTitle){
              _this.identity.push({type:res.LitigantTypeTitle[index].LitigantTypeNature,value:res.LitigantTypeTitle[index].LitigantTypeId,label:res.LitigantTypeTitle[index].LitigantTypeTitle})
            }
            _this.litigation = []
            for(var index in res.LitigationLawsuit){
              _this.litigation.push({value:res.LitigationLawsuit[index].LitigationLawsuitId,label:res.LitigationLawsuit[index].LitigationLawsuitName})
            }
          }
        })
      },
      checkConflict:function () {
        var _this = this
        if(_this.$route.query.checkConflict=='uncheck'){
          _this.$Modal.info({
            title:'系统提示',
            content:'未进行利冲检索。'
          })
          return
        }
        _this.peopleConflict = []
        var conflictData = []
        conflictData[0] = {
          id:1,
          retrieval:0,
          children:[]
        }
        conflictData[1] = {
          id:2,
          retrieval:1,
          children:[]
        }
        for(var i=0;i<_this.client.length;i++){
          conflictData[0].children.push(_this.client[i])
        }
        for(var i=0;i<_this.opposed.length;i++){
          conflictData[1].children.push(_this.opposed[i])
        }
        _this.send({
          headers:'C/Conflict',
          data:{
            InterestConflict:conflictData
          },
          success:function (res) {
            // if(_this.$route.query.detailed){
              if(res.personal){
                for(var index in res.personal){
                  _this.peopleConflict.push({
                    name:res.personal[index].LitigantName,//委托人
                    caseNum:res.personal[index].CaseNum,//项目案号
                    createDate:res.personal[index].CaseCreateTime,//项目录入时间
                    contactName:res.personal[index].CaseLinkman,//联系人
                    litigation:res.personal[index].LitigationLawsuitName//诉讼地位
                  })
                }
              }
              if(res.case){
                for(var index in res.case){
                  if(res.case[index].CaseCreateTime){
                    _this.projectConflict.push({
                      // name:res.case[index].LitigantName,//委托人
                      caseNum:res.case[index].CaseNum,//项目案号
                      createDate:res.case[index].CaseCreateTime,//项目录入时间
                      contactName:res.case[index].CaseLinkman,//联系人
                      delegableRole:res.case[index].LitigationStatusName,//代理何方
                      caseType:res.case[index].CaseTypetTitle//案件类型
                    })
                  }
                }
              }
            // }else{
              // _this.$Modal.warning({
              //   title:'系统消息',
              //   content:'发现冲突项目，请检查身份信息',
              //   onOk:function () {
              //     _this.$router.push({name:_this.lastRoute,query:{id:_this.$route.query.id,detailed:1}})
              //   }
              // })
            if(_this.projectConflict.length>0||_this.peopleConflict.length>0){
              _this.$Notice.error({
                title:'系统消息',
                desc:'发现冲突项目，请补充身份信息',
              })
              if(_this.$route.query.detailed!=1){
                _this.$router.push({name:_this.lastRoute,query:{id:_this.$route.query.id,detailed:1}})
              }
            }

            // }
            // CaseCreateTime: 1563104854
            // CaseExecutorId: "1,5"
            // CaseId: 42
            // CaseTitle: "新的项目A"
            // ContactPerson: null
            // ContactPersonMobile: null
            // LitigantAble: null
            // LitigantAddress: null
            // LitigantId: 81
            // LitigantIdCard: "2"
            // LitigantMobile: "3"
            // LitigantName: "1"
            // LitigantTypeId: null
            // LitigantsId: "83,81,82"
            // LitigationStatusId: 1
            // LitigationStatusName: "委托人"
          },

        })
      }
    },
    computed:{
      customerList:{
        get:function () {
          return this.$store.state.project.create.step1.customerList
        },
      },
      client:{
        get:function () {
          return this.$store.state.project.create.step1.client
        }
      },
      opposed:{
        get:function () {
          return this.$store.state.project.create.step1.opposed
        }
      }
    }
  }
</script>

